<template>
  <div class="mask">
    <img class="close" @click="cancel()"  src="static/images/close.png" />
    <div class="payitem">
      <div class="paytitle">
        <p class="payhead">Century Games</p>
      </div>
      <div id="dropin" ></div>
      <div class="loadimg">
        <img class="load" src="static/images/load.gif" />
      </div>
    </div>
  </div>
</template>

<script>
  import {getReservationOrder} from '@/api/index.js'
  export default {
    name: 'alipay',
    props: ['payinfo'],
    data() {
       return {
          baseurl: process.env.API_BASEURL,
          provider_order_id: null
       }
    },
    created(){
      if (this.provider_order) {
        this.checkOrderStatus()
      }
      this.getPreOrder()
    },
    methods: {
      cancel(){
        this.$parent.cancelpay()
      },
      // 获取预订单
      async getPreOrder() {
        window.open('https://openapi.alipay.com/gateway.do?app_id=2021003173611913&biz_content=%7B%22out_trade_no%22%3A%222010053882%22%2C%22product_code%22%3A%22QUICK_WAP_PAY%22%2C%22subject%22%3A%22%5Cu68a6%5Cu5883%5Cu4fa6%5Cu63a2VIP%5Cu652f%5Cu4ed8%22%2C%22total_amount%22%3A%220.01%22%7D&charset=utf-8&method=alipay.trade.wap.pay&notify_url=https%3A//payment-cn-sandbox.ifunplus.cn/return/alipay2016&quit_url=https%3A//vip-sandbox.campfiregames.cn/game%3Ftype%3Dquit%26game_id%3D20125&return_url=https%3A//vip-sandbox.campfiregames.cn/game%3Fgame_id%3D20125&sign_type=RSA2&timestamp=2023-02-13%2012%3A37%3A14&version=1.0&sign=CT5TUiRT9cDYuHJH6UI9qD1HMNlOVhSDi5NVRdE0caHsnKMmC/nfibKmrvInVywUYPvEZhbqB8ja3U0wmkrML0rOGuSmxmldlbqFKTJLv8lUtBrGjNMv8Z6PQ%2BP%2BVpDOGMqBy3LAzpMP%2BIq31DdcUe37//PVRv91fZh7jBrs2THgneTvlul6O0dkmiSxn3KNGJ0Q4djBSk5LFD34CMJ8R4MeQttKDjguKrjHfN/HEOzd77T1PKLpwbDS/AgVznBm65EhiGM7i2aXa9kcnXmABwLjOIBS3cUIHS/YhadFnRT0IdofEbc66UxnJg5ONgsKj8J6FJRNOCG9PvkT57nXZw%3D%3D')
        // const res = await getReservationOrder(this.payinfo)
        // if(res.data.code == 1){
        //   console.log(res);
        //   // const formStr = window.decodeURIComponent(res.data.data.gateway_data.alipay_params)
        //   // const oDiv = document.createElement('div');
        //   // oDiv.id = 'aipay_container'
        //   // oDiv.innerHTML = formStr
        //   // oDiv.style.position = 'absolute'
        //   // oDiv.style.top = '-999999px'
        //   // oDiv.style.left = '-999999px'
        //   // document.body.appendChild(oDiv)
        //   // const form = document.querySelector('#aipay_container form')
        //   // // form.setAttribute('target', '_blank'); // 新开窗口跳转
        //   // form.submit()

        //   window.location.href = 'https://openapi.alipay.com/gateway.do?app_id=2021003173611913&biz_content=%7B%22out_trade_no%22%3A%222010053882%22%2C%22product_code%22%3A%22QUICK_WAP_PAY%22%2C%22subject%22%3A%22%5Cu68a6%5Cu5883%5Cu4fa6%5Cu63a2VIP%5Cu652f%5Cu4ed8%22%2C%22total_amount%22%3A%220.01%22%7D&charset=utf-8&method=alipay.trade.wap.pay&notify_url=https%3A//payment-cn-sandbox.ifunplus.cn/return/alipay2016&quit_url=https%3A//vip-sandbox.campfiregames.cn/game%3Ftype%3Dquit%26game_id%3D20125&return_url=https%3A//vip-sandbox.campfiregames.cn/game%3Fgame_id%3D20125&sign_type=RSA2&timestamp=2023-02-13%2012%3A37%3A14&version=1.0&sign=CT5TUiRT9cDYuHJH6UI9qD1HMNlOVhSDi5NVRdE0caHsnKMmC/nfibKmrvInVywUYPvEZhbqB8ja3U0wmkrML0rOGuSmxmldlbqFKTJLv8lUtBrGjNMv8Z6PQ%2BP%2BVpDOGMqBy3LAzpMP%2BIq31DdcUe37//PVRv91fZh7jBrs2THgneTvlul6O0dkmiSxn3KNGJ0Q4djBSk5LFD34CMJ8R4MeQttKDjguKrjHfN/HEOzd77T1PKLpwbDS/AgVznBm65EhiGM7i2aXa9kcnXmABwLjOIBS3cUIHS/YhadFnRT0IdofEbc66UxnJg5ONgsKj8J6FJRNOCG9PvkT57nXZw%3D%3D'
        // } else {
        //   this.$parent.failpay("Order failed！");
        // }
      },
      // 查询支付结果
      async checkOrderStatus() {
        try {
          const res = await getReservationOrder(this.payinfo)
          if(res.data.code == 1){
            // 支付成功
            this.$parent.successpay(response.data.data)
          } else {
            setTimeout(() => {
              this.checkOrderStatus()
            }, 2000)
          }
        } catch (error) {
          setTimeout(() => {
            this.checkOrderStatus()
          }, 2000)
        }
      }
    }
  }
</script>

<style scoped>
  #dropin{
    text-align: center;
  }
  .payitem{
    width: 90%;
    background-color: #FFFFFF;
    margin: 0 auto;
    padding: 3%;
    max-height: 90%;
    overflow-y: auto;
    position: relative;
    margin-top: 1.25rem;
  }
  .loadmask{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    padding-top: 3.75rem;
    top: 0;
    left: 0;
  }
  .loadmask p{
    color: #FFFFFF;
    font-size: 0.875rem;
    text-align: center;
  }
  .paytitle p{
    font-size:1rem;
    line-height:1.875rem;
    margin-bottom: 0.625rem;
    text-align: center;
  }
  .payhead{
    font-family: "SemiBold";
  }
  .loadimg{
    height: 12.5rem;
  }
  .close{
    width: 1.875rem;
    height: 1.875rem;
    display: block;
    float: right;
    margin: 0.625rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/alipay.vue